import { render, staticRenderFns } from "./selected-object-pointer.vue?vue&type=template&id=2a2fd8a2&"
import script from "./selected-object-pointer.vue?vue&type=script&lang=js&"
export * from "./selected-object-pointer.vue?vue&type=script&lang=js&"
import style0 from "./selected-object-pointer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports